export const GROUP_ROLES = {
  standard: 'standard',
  owner: 'owner',
  administrator: 'administrator',
};
